import get from 'lodash/get';

import { Unauthorized } from '@ad-scripts/application/lib/error';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import generateId from 'src/lib/generateId';
import { logout } from 'src/actions/auth/authSlice';
import { AuthUtils } from 'src/models/Auth';

const EXCLUDE_ACTIVITY_TYPES = ['_ADMIN', 'IMITATE_ADMIN', 'IVR_SESSIONS_ADMIN'];

const agentActivityResource = createCollectionResource<any>({
  name: 'agentActivity',
  endpoint: 'v1/orgs/:orgId/agents/:agentId/activity',
  observerCreator: emptyObserverCreator,
});

const getActivityTypeFromPath = (path: string) => {
  const parts = path.split('/');
  // add the necessary translation
  // https://github.com/sagansystems/agent-desktop/blob/b8ada4efa5b58bf56c83e780924bd56fcccaf28a/src/scripts/presentation/components/liveboards/charts/agent_status_card.jsx#L335
  // to provide better/more descriptive text for the Agent Liveboards
  const activityType = `${get(parts, '[1]', '').toUpperCase().replace(/-/g, '_')}_ADMIN`;

  return activityType;
};

const add: sharedTypes.AppThunk =
  ({ type, page }: { type?: string; page?: string }) =>
  async (dispatch, getState, { gateways }) => {
    try {
      const auth = getState().auth;
      if (AuthUtils.isLoggedIn(auth)) {
        const activityType = type || getActivityTypeFromPath(page || '');
        if (!EXCLUDE_ACTIVITY_TYPES.includes(activityType)) {
          await gateways.agentActivity.add(
            auth.userId,
            { id: generateId(), agentId: auth.userId, timestamp: new Date().toISOString(), type: activityType },
            generateId()
          );
        }
      }
    } catch (err) {
      if (err instanceof Unauthorized) {
        dispatch(logout());
      }
    }
  };

agentActivityResource.effects.add = add;

export default agentActivityResource;
